// Google Maps directions deep link between two stops. A plain URL (no API key, nothing
// stored), so travellers get real bus/train lines that our planner can't route.
const TRAVEL_MODE = { walk: 'walking', foot: 'walking', transit: 'transit', car: 'driving', drive: 'driving', rideshare: 'driving' };

const point = (s) => (s && Number.isFinite(Number(s.lat)) && Number.isFinite(Number(s.lng)) ? `${Number(s.lat)},${Number(s.lng)}` : null);

export function directionsUrl(from, to, mode = 'transit') {
  const origin = point(from);
  const destination = point(to);
  if (!origin || !destination) return null;
  const qs = new URLSearchParams({ api: '1', origin, destination, travelmode: TRAVEL_MODE[mode] || 'transit' });
  return `https://www.google.com/maps/dir/?${qs.toString()}`;
}
